/* kreuzkreativ – Grablaterne: eine Seite (Acrylplatte) zeichnen.
   Wird vom Gestalter (Vorschau) UND von der Druckdatei-Seite (/pages/laserdatei?view=druckdatei) benutzt – dieselbe Rechnung,
   damit der Druck genau der Vorschau entspricht.
   Maße in mm. Druckdatei 120 × 174 mm = Endformat 110 × 164 mm + 5 mm Beschnitt rundum (Vorgabe WirmachenDruck), Sicherheitsabstand 3 mm.
   Seiten: vorne (Foto oder Motivbild mit Name/Daten), hinten (zweites Motivbild mit Spruch – bei Foto-Laterne zusätzlich Name/Daten), links/rechts (ruhiges Seitenbild, rechts gespiegelt). */
(function(G){
'use strict';
var W = 120, H = 174, BL = 5;
var FIN = {x:5, y:5, w:110, h:164};          // Endformat (wird zugeschnitten)
var VIS = {x:10, y:13.5, w:100, h:147};      // sichtbar im Rahmen (Glasfläche 10 × 14,7 cm, Platte mittig)
var SAFE = {x:12, y:16, w:96, h:142};        // Text bleibt hier drin (sichtbare Fläche mit Abstand zum Rahmen)
var P = {x:17, w:86, pad:7, r:2.5, fill:'rgba(255,255,255,0.86)', ink:'#2b2b2b'};
var MET = {sans:{a:0.905, d:0.212}, script:{a:0.92, d:0.28}};
var FONTS = {sans:'Arimo, Arial, sans-serif', script:'"kkgt Dancing", cursive'};
var PART = /^(geb\.?|geborene|geborener|verw\.?|verwitwete|gen\.?|genannt)$/i;
var NOBLE = /^(von|vom|van|der|den|de|del|di|da|du|zu|zum|zur|ten|ter|la|le)$/i;
var SIDES = ['vorne', 'rechts', 'hinten', 'links'];
var NAMES = {vorne:'Vorderseite', rechts:'rechte Seite', hinten:'Rückseite', links:'linke Seite'};

function clamp(v, a, b){ return v < a ? a : (v > b ? b : v); }
function fam(f){ return f === 'script' ? FONTS.script : FONTS.sans; }

/* Messen (Breite bei Schriftgröße 1 mm) */
var mctx = null, wc = {};
function tw(t, f){
  var k = f + '|' + t; if (wc[k] != null) return wc[k];
  if (!mctx) mctx = document.createElement('canvas').getContext('2d');
  mctx.font = '400 100px ' + fam(f); var w = mctx.measureText(t).width/100; wc[k] = w; return w;
}
function resetMeasure(){ wc = {}; }
function base(top, size, lh, f){ var m = MET[f]; return top + lh*size/2 + (m.a - m.d)/2*size; }

/* Name: eine Zeile; wird sie zu klein, Vorname / Nachname (+ „geb. …“) untereinander */
function nameParts(nm){
  var w = String(nm || '').split(' ').filter(Boolean), p = w.length;
  for (var i = 1; i < w.length; i++) if (PART.test(w[i])){ p = i; break; }
  var main = w.slice(0, p), extra = w.slice(p).join(' ');
  if (main.length < 2) return [main.join(' '), extra].filter(Boolean);
  var j = main.length - 1; while (j > 1 && NOBLE.test(main[j-1])) j--;
  return [main.slice(0, j).join(' '), main.slice(j).join(' '), extra].filter(Boolean);
}
function fitLines(lines, f, start, min, maxW){
  var s = start, over = false;
  lines.forEach(function(l){ var w = tw(l, f); if (w*s > maxW){ var n = maxW/w; if (n < min){ s = min; over = true; } else s = n; } });
  return {lines:lines, s:s, over:over};
}
function nameBlock(nm, start, min, maxW){
  var one = fitLines([nm], 'script', start, min, maxW);
  if (!one.over && one.s >= start*0.8) return one;
  var parts = nameParts(nm); if (parts.length < 2) return one;
  var two = fitLines(parts, 'script', start*0.9, min, maxW);
  return (two.s > one.s || one.over) ? two : one;
}

/* Spruch: Zeilenumbrüche des Kunden bleiben. Passt eine Zeile nicht, wird zuerst nach Komma/Satzzeichen umbrochen,
   erst dann an Wortgrenzen – und dann möglichst gleich lang (nicht ein Wort allein in der letzten Zeile). */
function greedy(words, f, size, maxW){
  var out = [], line = '';
  words.forEach(function(w){ var t = line ? line + ' ' + w : w; if (!line || tw(t, f)*size <= maxW) line = t; else { out.push(line); line = w; } });
  if (line) out.push(line); return out;
}
function balanced(words, f, size, maxW){
  var g = greedy(words, f, size, maxW); if (g.length < 2) return g;
  var lo = 0, hi = maxW;
  for (var i = 0; i < 14; i++){ var mid = (lo + hi)/2; if (greedy(words, f, size, mid).length <= g.length) hi = mid; else lo = mid; }
  return greedy(words, f, size, hi);
}
function clauses(par){
  var out = [], cur = [];
  par.split(' ').forEach(function(w){ cur.push(w); if (/[,;:!?]$/.test(w) || (/[.]$/.test(w) && !/^(\d+\.?)+$/.test(w) && w.length > 3)){ out.push(cur.join(' ')); cur = []; } });
  if (cur.length) out.push(cur.join(' ')); return out;
}
function wrap(text, f, size, maxW){
  var out = [];
  String(text || '').split(/\n/).forEach(function(par){
    par = par.replace(/\s+/g, ' ').trim(); if (!par) return;
    if (tw(par, f)*size <= maxW){ out.push(par); return; }
    var line = '';
    clauses(par).forEach(function(c){
      var t = line ? line + ' ' + c : c;
      if (tw(t, f)*size <= maxW){ line = t; return; }
      if (line) out.push(line);
      if (tw(c, f)*size <= maxW){ line = c; return; }
      out.push.apply(out, balanced(c.split(' '), f, size, maxW)); line = '';   // langer Satzteil: danach neue Zeile
    });
    if (line) out.push(line);
  });
  return out;
}
function spruchBlock(sp, start, min, maxW, maxLines){
  if (!String(sp || '').trim()) return {lines:[], s:start, over:false};
  for (var s = start; s >= min - 0.001; s -= 0.25){
    var L = wrap(sp, 'sans', s, maxW), wide = L.some(function(l){ return tw(l, 'sans')*s > maxW; });
    if (L.length <= maxLines && !wide) return {lines:L, s:s, over:false};
  }
  var L2 = wrap(sp, 'sans', min, maxW);
  return {lines:L2, s:min, over:true};
}

/* Textfeld einer Seite: kind 'front' (Name + Daten), 'back' (Spruch), 'backfoto' (Name + Daten + Spruch) */
function textLayout(kind, d){
  var IW = P.w - 2*P.pad, E = {}, ops = [], y = 0, info = {};
  var withName = kind !== 'back', withSp = kind !== 'front';
  var nb = null, dl = [], dsz = 4.8, sb = null;
  if (withName && d.nm){
    nb = nameBlock(d.nm, kind === 'front' ? 12 : 10, 7, IW); if (nb.over) E.name = 1;
  }
  if (withName){
    var a = d.gb ? '* ' + d.gb : '', b = d.gs ? '† ' + d.gs : '';
    if (a && b){ var one = a + '      ' + b; if (tw(one, 'sans')*dsz <= IW) dl = [one]; else dl = [a, b]; }
    else dl = [a || b].filter(Boolean);
    dl.forEach(function(l){ var w = tw(l, 'sans'); if (w*dsz > IW){ dsz = Math.max(3.6, IW/w); if (w*3.6 > IW) E.dates = 1; } });
  }
  if (withSp){
    sb = spruchBlock(d.sp, kind === 'back' ? 6 : 5.4, 4.2, IW, kind === 'back' ? 7 : 5); if (sb.over) E.sp = 1;
    if (!sb.lines.length) sb = null;
  }
  // Höhe
  var parts = [];
  if (nb) parts.push({h:nb.lines.length*nb.s*1.22, draw:function(t){ nb.lines.forEach(function(l, i){ ops.push({t:'text', s:l, f:'script', size:nb.s, x:W/2, y:base(t + i*nb.s*1.22, nb.s, 1.22, 'script'), r:'N'}); }); }});
  if (dl.length) parts.push({h:dl.length*dsz*1.55, gap:nb ? 2.5 : 0, draw:function(t){ dl.forEach(function(l, i){ ops.push({t:'text', s:l, f:'sans', size:dsz, x:W/2, y:base(t + i*dsz*1.55, dsz, 1.55, 'sans'), r:'D'}); }); }});
  if (sb){
    var g = parts.length ? 4.5 : 0;
    if (parts.length) parts.push({h:0.3, gap:g, draw:function(t){ ops.push({t:'line', x1:W/2 - 12, y1:t + 0.15, x2:W/2 + 12, y2:t + 0.15, w:0.3}); }});
    parts.push({h:sb.lines.length*sb.s*1.45, gap:parts.length ? g : 0, draw:function(t){ sb.lines.forEach(function(l, i){ ops.push({t:'text', s:l, f:'sans', size:sb.s, x:W/2, y:base(t + i*sb.s*1.45, sb.s, 1.45, 'sans'), r:'S'}); }); }});
  }
  if (!parts.length) return {panel:null, ops:[], E:E, info:info};
  var ch = 0; parts.forEach(function(p){ ch += (p.gap || 0) + p.h; });
  var ph = ch + 2*P.pad;
  var cy = kind === 'front' ? 122 : 87;
  var py = clamp(cy - ph/2, SAFE.y, SAFE.y + SAFE.h - ph);
  if (ph > SAFE.h){ E.all = 1; py = SAFE.y; }
  y = py + P.pad; parts.forEach(function(p){ y += (p.gap || 0); p.draw(y); y += p.h; });
  info.name = nb ? {lines:nb.lines, s:nb.s} : null; info.dates = dl.length ? dsz : null; info.sp = sb ? {lines:sb.lines, s:sb.s} : null;
  return {panel:{x:P.x, y:py, w:P.w, h:ph}, ops:ops, E:E, info:info};
}

/* Foto-Ausschnitt: z ≥ 1 füllt die ganze Platte (inkl. Beschnitt), cx/cy = Mitte in 0…1 */
function clampCrop(iw, ih, c){
  var z = clamp(+c.z || 1, 1, 4), s = Math.max(W/iw, H/ih)*z, hw = W/(2*iw*s), hh = H/(2*ih*s);
  var cx = +c.cx, cy = +c.cy; if (!isFinite(cx)) cx = 0.5; if (!isFinite(cy)) cy = 0.5;
  return {z:Math.round(z*1000)/1000, cx:Math.round(clamp(cx, hw, 1 - hw)*10000)/10000, cy:Math.round(clamp(cy, hh, 1 - hh)*10000)/10000};
}
function startCrop(iw, ih){ return clampCrop(iw, ih, {z:1, cx:0.5, cy:ih > iw*1.2 ? 0.45 : 0.5}); }
/* Wie viele Bildpunkte je mm hat das Foto auf der Platte? (300 dpi ≈ 11,8; ab ca. 6 noch gut) */
function fotoPpm(iw, ih, c){ var cc = clampCrop(iw, ih, c || {}); return 1/(Math.max(W/iw, H/ih)*cc.z); }

function cover(x, img, k, mirror){
  var iw = img.naturalWidth || img.width, ih = img.naturalHeight || img.height, r = iw/ih, t = W/H, sw, sh, sx, sy;
  if (r > t){ sh = ih; sw = ih*t; sx = (iw - sw)/2; sy = 0; } else { sw = iw; sh = iw/t; sx = 0; sy = (ih - sh)/2; }
  x.save();
  if (mirror){ x.translate(W*k, 0); x.scale(-1, 1); }
  x.imageSmoothingEnabled = true; x.imageSmoothingQuality = 'high';
  x.drawImage(img, sx, sy, sw, sh, 0, 0, W*k, H*k); x.restore();
}
function rr(x, a, b, w, h, r){ x.beginPath(); x.moveTo(a + r, b); x.arcTo(a + w, b, a + w, b + h, r); x.arcTo(a + w, b + h, a, b + h, r); x.arcTo(a, b + h, a, b, r); x.arcTo(a, b, a + w, b, r); x.closePath(); }

/* Eine Seite zeichnen. ctx: Zeichenfläche, Ursprung = linke obere Ecke der Druckdatei; k = Pixel je mm.
   d = {foto, nm, gb, gs, sp, fz, fcx, fcy}; R = {v, h, s: Motivbilder vorne/hinten/Seite, foto: Bild}; opt.placeholder: Text für fehlendes Foto */
function drawSide(x, side, d, R, k, opt){
  opt = opt || {};
  x.save();
  x.fillStyle = '#e9e6df'; x.fillRect(0, 0, W*k, H*k);
  var L = null;
  if (side === 'vorne' && d.foto){
    if (R.foto){
      var iw = R.foto.naturalWidth || R.foto.width, ih = R.foto.naturalHeight || R.foto.height, c = clampCrop(iw, ih, {z:d.fz, cx:d.fcx, cy:d.fcy});
      var s = Math.max(W/iw, H/ih)*c.z, dw = iw*s, dh = ih*s, dx = W/2 - c.cx*dw, dy = H/2 - c.cy*dh;
      x.imageSmoothingEnabled = true; x.imageSmoothingQuality = 'high';
      x.drawImage(R.foto, dx*k, dy*k, dw*k, dh*k);
    } else {
      var g = x.createLinearGradient(0, 0, 0, H*k); g.addColorStop(0, '#cfcbc3'); g.addColorStop(1, '#a9a49b'); x.fillStyle = g; x.fillRect(0, 0, W*k, H*k);
      x.strokeStyle = 'rgba(255,255,255,.85)'; x.lineWidth = 0.8*k; x.setLineDash([3*k, 2.2*k]); rr(x, 16*k, 16*k, (W - 32)*k, (H - 32)*k, 4*k); x.stroke(); x.setLineDash([]);
      // kleine Kamera
      x.fillStyle = 'rgba(255,255,255,.9)'; rr(x, (W/2 - 9)*k, (H/2 - 16)*k, 18*k, 12*k, 2*k); x.fill();
      x.fillStyle = '#b3aea5'; x.beginPath(); x.arc((W/2)*k, (H/2 - 10)*k, 3.6*k, 0, 2*Math.PI); x.fill();
      x.fillStyle = 'rgba(255,255,255,.95)'; x.textAlign = 'center'; x.font = '400 ' + (8*k) + 'px ' + FONTS.sans; x.fillText(opt.placeholder || 'Ihr Foto', W/2*k, (H/2 + 6)*k);
    }
  } else {
    // Motiv je Seite: vorne R.v, hinten R.h, links/rechts R.s (rechts gespiegelt); fehlt ein Bild, das vordere nehmen
    var im = (side === 'vorne' ? R.v : side === 'hinten' ? R.h : R.s) || R.v;
    if (im) cover(x, im, k, side === 'rechts');
    if (side === 'vorne') L = textLayout('front', d);
    else if (side === 'hinten') L = textLayout(d.foto ? 'backfoto' : 'back', d);
  }
  if (L && L.panel){
    x.fillStyle = P.fill; rr(x, L.panel.x*k, L.panel.y*k, L.panel.w*k, L.panel.h*k, P.r*k); x.fill();
    x.fillStyle = P.ink; x.strokeStyle = P.ink; x.textBaseline = 'alphabetic'; x.textAlign = 'center';
    L.ops.forEach(function(o){
      if (o.t === 'text'){ x.font = '400 ' + (o.size*k) + 'px ' + fam(o.f); x.fillText(o.s, o.x*k, o.y*k); }
      else { x.lineWidth = Math.max(1, o.w*k); x.globalAlpha = 0.55; x.beginPath(); x.moveTo(o.x1*k, o.y1*k); x.lineTo(o.x2*k, o.y2*k); x.stroke(); x.globalAlpha = 1; }
    });
  }
  x.restore();
  return L;
}

/* Alle Prüfungen für die Bestellung (Text zu lang usw.) */
function check(d){
  var E = {}, info = {};
  var f = textLayout('front', d), b = textLayout(d.foto ? 'backfoto' : 'back', d);
  if (!d.foto){ Object.keys(f.E).forEach(function(k){ E[k] = 1; }); info.vorne = f.info; }
  Object.keys(b.E).forEach(function(k){ E[k] = 1; }); info.hinten = b.info;
  return {E:E, info:info};
}

G.KKLaterne = {W:W, H:H, BL:BL, FIN:FIN, VIS:VIS, SAFE:SAFE, SIDES:SIDES, NAMES:NAMES, FONTS:FONTS,
  drawSide:drawSide, textLayout:textLayout, check:check, clampCrop:clampCrop, startCrop:startCrop, fotoPpm:fotoPpm, resetMeasure:resetMeasure};
})(window);